import { useState } from 'react'
import DeclineModal from "../Modals/declineModal"
import AcceptModal from "../Modals/acceptModal"
import { HiOutlineExternalLink } from 'react-icons/hi';

/**
 * Returns the Project DOI row component.
 * 
 * @param {*} param0 
 * @returns The Project DOI row component.
 */
const ProjectRow = ({
  project,
  formatUNIX,
  projectPublishStatusChange,
  updateProjectInfo,
}) => {
  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const [openAcceptModal, setOpenAcceptModal] = useState(false);

  return (
    <>
      <tr className="py-12" key={project.id || project.PK}>
        <td className="w-full max-w-0 py-4 pl-6 pr-3 text-sm sm:text-base font-medium text-black sm:w-auto sm:max-w-none sm:pl-6">
            <div className='flex hover:underline cursor-pointer' 
              onClick={() => {
                  window.open("/metadata-display/" + project.id);
                }}>
              <a className="whitespace-normal font-medium break-all">
                {project.title}
              </a>
              <div className='pl-1.5'>
                <HiOutlineExternalLink/>
              </div>
            </div>

            <dl className="font-normal lg:hidden">
              <dt className="sr-only sm:hidden">Created By</dt>
              <dd className="mt-1 truncate text-gray-500 sm:hidden whitespace-normal break-all">{JSON.parse(project.stakeholders)[0].name}</dd>
            </dl>
        </td>

        <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
          {JSON.parse(project.stakeholders)[0].name}
        </td>

        <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
          {formatUNIX(project.createdAt)}
        </td>

        <td className="py-4 pl-3 pr-6 space-y-3 text-right text-sm sm:text-base font-medium sm:space-y-0 sm:space-x-3 sm:pr-6">
          <div className="sm:flex sm:space-x-2 sm:space-y-0 space-y-2">
            <button
              /* Sets the publishStatus to published but doesn't actually update the item in the table yet. Updates the item in the table inside the modal */
              onClick={() => { setOpenAcceptModal(true); projectPublishStatusChange(project.id, "published"); }}
              data-cy={"accept-" + project.title}
              type="button"
              className="rounded-md w-full py-1 px-4 text-sm font-medium shadow-sm text-gray-700 bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Accept
            </button>
            <button
              /* Sets the publishStatus to rejected but doesn't actually update the item in the table yet. Updates the item in the table inside the modal */
              onClick={() => { setOpenDeclineModal(true); projectPublishStatusChange(project.id, "rejected"); }}
              type="button"
              data-cy={"reject-" + project.title}
              className="rounded-md w-full py-1 px-4 text-sm font-medium shadow-sm text-gray-700 bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Reject
            </button>
          </div>
        </td>
        <DeclineModal
          setOpenDeclineModal={setOpenDeclineModal}
          updateProjectInfo={updateProjectInfo}
          openDeclineModal={openDeclineModal}
          projectInfo={project}
        />
        <AcceptModal
          setOpenAcceptModal={setOpenAcceptModal}
          updateProjectInfo={updateProjectInfo}
          openAcceptModal={openAcceptModal}
          projectInfo={project}
        />
      </tr>
    </>
  );
};

export default ProjectRow;